export default "__VITE_ASSET__9b3efbe5__"